import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, keyframes, transition } from '@angular/animations';
import { Observable } from 'rxjs/Observable';

@Component({
  selector: 'itpx-benefits',
  templateUrl: './benefits.component.html',
  styleUrls: ['./benefits.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({transform: 'translateX(0)'})),
      transition('void => *', [
        animate(600, keyframes([
          style({opacity: 0, transform: 'translateX(-100%)', offset: 0}),
          style({opacity: 1, transform: 'translateX(15px)',  offset: 0.3}),
          style({opacity: 1, transform: 'translateX(0)',     offset: 1.0})
        ]))
      ]),
      transition('* => void', [
        animate(600, keyframes([
          style({opacity: 1, transform: 'translateX(0)',     offset: 0}),
          style({opacity: 1, transform: 'translateX(-15px)', offset: 0.7}),
          style({opacity: 0, transform: 'translateX(100%)',  offset: 1.0})
        ]))
      ])
    ])
  ]
})
export class BenefitsComponent implements OnInit {
  @Input() id: string;
  @Input() proceed: Observable<string>;
  @Output() canProceed = new EventEmitter<boolean>();
  staggeringItems: any[];
  next=0;
  constructor() { }

  ngOnInit() {
    this.staggeringItems = [];
    this.doNext();
    this.proceed.filter(input => input === this.id).subscribe(_ => this.canProceed.emit(true));
  }
  readonly path = 'https://www.leapest.com/INTERSHOP/static/WFS/inSPIRED-inTRONICS_Business-Site/-/inSPIRED-inTRONICS_Business-smb-responsive/en_US/icons/';

  readonly configurations: { index: number, title: string, image: string, subText: string }[] = [
    {
      index: 1,
      title: 'buyer.to.seller.non.admin.tile.one.title',
      image: `${this.path}sign-in-alt-regular.png`,
      subText: 'buyer.to.seller.non.admin.tile.one.subtext'
    },
    {
      index: 2,
      title: 'buyer.to.seller.non.admin.tile.two.title',
      image: `${this.path}magic-regular.png`,
      subText: 'buyer.to.seller.non.admin.tile.two.subtext'
    },
    {
      index: 3,
      title: 'buyer.to.seller.non.admin.tile.three.title',
      image: `${this.path}price-tag.png`,
      subText: 'buyer.to.seller.non.admin.tile.three.subtext'
    },
    {
      index: 4,
      title: 'buyer.to.seller.non.admin.tile.four.title',
      image: `${this.path}get-paid.png`,
      subText: 'buyer.to.seller.non.admin.tile.four.subtext'
    },
  ]
  doNext() {
    if(this.next < this.configurations.length) {
      this.staggeringItems.push(this.configurations[this.next++]);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/buyer-to-seller/benefits/benefits.component.ts